import { useTranslation } from 'react-i18next'

import {
  DangerButton,
  TertiaryButton,
  Text,
  VStack,
} from '@enechain/ecloud-designsystem'

import { Modal } from '~/components/common/Modal'
import { WithdrawNoBidWindowNote } from '~/pages/SpotBidding/components/WithdrawNoBidWindowNote'

type Props = {
  isOpen: boolean
  /** 取り下げる通常入札の札の数。 */
  spotCount: number
  /** 取り下げるブロック入札のグループ数 (組になる Leg をまとめて 1 件と数える)。 */
  blockCount: number
  /** 入札締切 (= 受渡日前日 10:00 JST)。 札なし窓の注記の残り時間に使う。 */
  deadline: Date
  /** 残り時間の基準時刻 (= 現在時刻)。 */
  now: Date
  /** 取下 RPC の実行中。 確認ボタンを押せなくする。 */
  isSubmitting: boolean
  onClose: () => void
  onConfirm: () => void
}

/**
 * 入札中の札の一括取下の確認ダイアログ (AC-BSP-116)。 通常入札タブ・ブロック入札タブの
 * どちらの ⋯ メニューからでも、 通常入札とブロック入札の両方の件数を出す。
 *
 * 取り下げた札は元に戻せないので、 件数の確認と、 1 件の取下 (AC-BSP-057) と同じ札なし窓の
 * 注記を必ず出す。
 */
export const BulkWithdrawConfirmModal = ({
  isOpen,
  spotCount,
  blockCount,
  deadline,
  now,
  isSubmitting,
  onClose,
  onConfirm,
}: Props): React.ReactElement => {
  const { t } = useTranslation()
  return (
    <Modal
      footer={
        <>
          <TertiaryButton marginRight={3} onClick={onClose}>
            {t('common:action.cancel')}
          </TertiaryButton>
          <DangerButton loading={isSubmitting} onClick={onConfirm}>
            {t('page:biddingSpot.withdrawConfirm.confirm')}
          </DangerButton>
        </>
      }
      isOpen={isOpen}
      onClose={onClose}
      size="sm"
      title={t('page:biddingSpot.bulkWithdraw.title')}
    >
      <VStack align="stretch" gap={3}>
        <Text>
          {t('page:biddingSpot.bulkWithdraw.body', {
            normal: spotCount,
            block: blockCount,
          })}
        </Text>
        {blockCount > 0 && (
          <Text>{t('page:biddingSpot.bulkWithdraw.blockNote')}</Text>
        )}
        <WithdrawNoBidWindowNote deadline={deadline} now={now} />
      </VStack>
    </Modal>
  )
}
